



























































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import AlertMessage from "@/components/atoms/AlertMessage.vue";
import { IAlertInfo } from "@/types";
import Modal from "@/components/atoms/Modal.vue";
import ChangePassword from "@/components/molecules/ChangePassword.vue";
import Utils from "@/common/utils";
import { LoginUserStore } from "@/store";
import { IChangePasswordParameters } from "@/store/modules/loginUser";
import { Auth } from "aws-amplify";
import MESSAGE from "@/assets/json/message.json";

@Component({
  components: { AlertMessage, Modal, ChangePassword },
})
export default class Topbar extends Vue {
  name: "Topbar";
  private successAlertList: IAlertInfo[] = [];
  private dangerAlertList: IAlertInfo[] = [];

  get displayName() {
    return !this.lastName || !this.firstName
      ? ""
      : `${this.lastName} ${this.firstName}`;
  }

  get changePasswordModalId() {
    return "changePasswordModalId";
  }

  @Prop({ default: "" })
  private lastName: string;

  @Prop({ default: "" })
  private firstName: string;

  private onClickChangePasswordLink(): void {
    this.$bvModal.show(this.changePasswordModalId);
  }

  private async onClickChangePasswordButton(
    securityCode: string,
    currentPassword: string,
    newPassword: string,
    newPasswordConfirm: string
  ): Promise<void> {
    try {
      this.clearAlertList();

      if (newPassword !== newPasswordConfirm) {
        this.dangerAlertList = [
          {
            item: "NOT_MATCH_PASSWORD",
            message: MESSAGE.EI004,
          },
        ];
        return;
      }

      Utils.showTransparentLoadingModal(this.$bvModal);

      const user = await Auth.currentAuthenticatedUser();
      const token: string = user.signInUserSession.accessToken.jwtToken;
      const params: IChangePasswordParameters = {
        user_id: LoginUserStore.getLoginUser.user_id,
        access_token: token,
        current_password: currentPassword,
        new_password: newPassword,
      };
      await LoginUserStore.changePassword(params);
      this.successAlertList = [
        {
          item: "SUCCESS001",
          message: MESSAGE.SUCCESS001,
        },
      ];
    } catch (errorInfos) {
      if (errorInfos) {
        if (Array.isArray(errorInfos)) {
          errorInfos.forEach((error: any) => {
            if (error.item && error.message) {
              this.dangerAlertList.push({
                item: error.item,
                message: error.message,
              });
            }
          });
        }
      }
      if (this.dangerAlertList.length == 0) {
        this.dangerAlertList.push(Utils.getCommonAlertInfo());
      }
    } finally {
      Utils.hideTransparentLoadingModal(this.$bvModal);
    }
  }

  private hideChangePasswordModal(): void {
    this.successAlertList = [];
    this.$bvModal.hide(this.changePasswordModalId);
  }

  private onClickLogoutLink(): void {
    Utils.logout();
  }

  private clearAlertList(): void {
    this.successAlertList = [];
    this.dangerAlertList = [];
  }
}
